import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const CookiePolicyPage = () => {
  return <CMSPage pageType="cookie-policy" />;
};

export default CookiePolicyPage;
